var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h3',[_vm._v("Deposits & Vouchers")]),_c('TransactionList',{attrs:{"canAdd":true,"canEdit":true,"canDelete":true,"defaultType":"DEPOSIT"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }